module.exports = __webpack_public_path__ + "0501f65823006ed943b7c5079bd92a1e.jpg";